<template>
	<div class="wrap">
		<div style="text-align: center;opacity: 0.5;font-size:12px;padding: 4px;">此申请由「ERP」应用提交</div>
		<div id="msg-title">
			<img :src="avatar" alt="" id="avatar">
			{{ title }}
			<span v-if="statusText" style="font-size: 10px;color: #05ad05;background: #cef9ce;margin-left: 6px;padding: 1px 2px;min-width: 32px;">
				{{ statusText }}
			</span>
		</div>
		
		<div id="content" v-html="content">
			
		</div>
	</div>
</template>

<script>
	export default {
	  components: {},
	  props: {},
	  data() {
	    return {
	      title: '',
				content: '',
				statusText: '',
				avatar: '',
				id: null,
	    };
	  },
		created() {
			this.id = this.$route.params.id
			this.init();
		},
		methods: {
			init() {
				this.getData();
			},
			getData() {
				this.$post(this.$api.stGetApprovalData, {'id': this.id}).then((res) => {
				  if (res.code !== 1) {
				    this.$toast.fail(res.msg ? res.msg : '获取失败');
				  } else {
				    this.title = res.data.title;
						this.content = res.data.content;
						this.statusText = res.data.status_text;
						this.avatar = res.data.avatar;
				  }
				});
			}
		}
	}
</script>

<style lang="scss">
	.wrap {
		width: 100%;
		height: 100vh;
		overflow: auto;
	}
	
	#content {
		margin-top: 10px;	
		background: white;
		padding: 24px 16px;
		min-height: 150px;
		font-size: 14px;
		p {
			padding: 5px;
		}
	}
	
	#msg-title {
		padding: 26px 12px;
		background: white;
		position: relative;
		background: white;
		display: flex;
		align-items: center;
		font-size: 16px;
	}
	
	#avatar {
		width : 32px;
		height: 32px;
		margin-right: 12px;	
	}
</style>